import { render } from "./ModalCubicationTypes.vue?vue&type=template&id=54f1ef70"
import script from "./ModalCubicationTypes.vue?vue&type=script&lang=js"
export * from "./ModalCubicationTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__